export default "__VITE_ASSET__Cm2Pn8q0__"